module.exports = __webpack_public_path__ + "img/youmu konpaku mysterious sword master_sc1.10377ad7.png";